export enum RR_TABLE_FIELD_TYPE {
  STRING = 'string',
  DATE = 'date',
  DATETIME = 'datetime',
  BATCH_SELECT = 'batchSelect',
  GUID = 'guid',
  NUMBER = 'number',
  BOOLEAN = 'boolean',
  HTML = 'html',
  THUMBNAIL = 'thumbnail',
  TAGS = 'tags',
}
